document.addEventListener('DOMContentLoaded', function () {
  const navItems = document.querySelectorAll('.faq-navigation--item-head');

  navItems.forEach((item) => {
    item.addEventListener('click', function () {
      const anchor = this.getAttribute('data-anchor');
      const targetElement = document.getElementById(anchor);

      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 50,
          behavior: 'smooth',
        });
      }
    });
  });

  const faqQuestions = document.querySelectorAll('.faq--question');

  faqQuestions.forEach((question) => {
    const questionTop = question.querySelector('.faq--question-top');
    const answer = question.querySelector('.faq--question-bottom');

    if (questionTop && answer) {
      answer.style.maxHeight = '0px';

      questionTop.addEventListener('click', function () {
        faqQuestions.forEach((q) => {
          const ans = q.querySelector('.faq--question-bottom');
          if (q !== question) {
            ans.style.maxHeight = '0px';
            q.classList.remove('active');
          }
        });

        if (answer.style.maxHeight === '0px' || answer.style.maxHeight === '') {
          answer.style.maxHeight = answer.scrollHeight + 'px';
          question.classList.add('active');
        } else {
          answer.style.maxHeight = '0px';
          question.classList.remove('active');
        }
      });
    }
  });
});
